// extracted by mini-css-extract-plugin
export default {"secondContainer":"Second_secondContainer__Rwfkp","rightImage":"Second_rightImage__cbKLP","secondHeading":"Second_secondHeading__xa-DL","secondContent":"Second_secondContent__2PLzz"};